import { render, staticRenderFns } from "./ExamFeeRequestStudent.vue?vue&type=template&id=f1fdebbe"
import script from "./ExamFeeRequestStudent.vue?vue&type=script&lang=js"
export * from "./ExamFeeRequestStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports